<app-modal
  [(open)]="open"
  [title]="modalTitle"
  size="large"
  (closed)="closeDialog()"
>
  <form class="flex flex-col gap-[18px]">
    <!-- Name -->
    <app-text-input
      [(ngModel)]="name"
      name="name"
      label="Name"
      [disabled]="isViewMode"
      placeholder="Enter device configuration name"
    />

    <!-- Timezone -->
    <app-text-input
      [(ngModel)]="timezone"
      name="timezone"
      label="Timezone"
      [disabled]="isViewMode"
      placeholder="e.g. UTC+1"
    />

    <!-- Time Sync URL -->
    <app-text-input
      [(ngModel)]="timeSyncUrl"
      name="timeSyncUrl"
      label="Time Sync URL"
      [disabled]="isViewMode"
      placeholder="Enter time sync URL"
    />

    <!-- Display dimensions -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <app-number-input
        [(ngModel)]="displayWidth"
        name="displayWidth"
        label="Display Width"
        [disabled]="isViewMode"
      />
      <app-number-input
        [(ngModel)]="displayHeight"
        name="displayHeight"
        label="Display Height"
        [disabled]="isViewMode"
      />
    </div>

    <!-- Display Ports -->
    <app-form-field label="Display Ports">
      <div class="flex flex-col gap-3">
        @for (port of ports; track trackByIndex(i, port); let i = $index) {
          <div class="flex flex-col gap-3 rounded-card bg-sunken p-4 shadow-hairline">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <app-text-input
                [(ngModel)]="port.portName"
                name="portName-{{ i }}"
                label="Port Name"
                [disabled]="isViewMode"
                placeholder="Port name"
              />
              <app-number-input
                [(ngModel)]="port.rowNumber"
                name="rowNumber-{{ i }}"
                label="Row Number"
                [disabled]="isViewMode"
              />
              <app-number-input
                [(ngModel)]="port.columnNumber"
                name="columnNumber-{{ i }}"
                label="Column Number"
                [disabled]="isViewMode"
              />
              <app-number-input
                [(ngModel)]="port.width"
                name="width-{{ i }}"
                label="Width"
                [disabled]="isViewMode"
              />
              <app-number-input
                [(ngModel)]="port.height"
                name="height-{{ i }}"
                label="Height"
                [disabled]="isViewMode"
              />
              <app-number-input
                [(ngModel)]="port.vcom"
                name="vcom-{{ i }}"
                label="VCOM"
                [disabled]="isViewMode"
              />
              <app-text-input
                [(ngModel)]="port.waveform"
                name="waveform-{{ i }}"
                label="Waveform"
                [disabled]="isViewMode"
                placeholder="Waveform"
              />
              <app-number-input
                [(ngModel)]="port.epdFrequency"
                name="epdFrequency-{{ i }}"
                label="EPD Frequency"
                [disabled]="isViewMode"
              />
            </div>

            <div class="flex items-center justify-between">
              <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
                <app-toggle
                  [(ngModel)]="port.reverseOrientation"
                  name="reverseOrientation-{{ i }}"
                  [disabled]="isViewMode"
                />
                Reverse Orientation
              </label>
              @if (!isViewMode) {
                <button
                  type="button"
                  (click)="removeDisplayPort(i)"
                  class="px-1 text-[13px] font-semibold text-danger hover:underline"
                >
                  Remove Port
                </button>
              }
            </div>
          </div>
        }
        @if (!isViewMode) {
          <button
            type="button"
            (click)="addDisplayPort()"
            class="self-start px-2 text-[13px] font-semibold text-link hover:underline"
          >
            + Add Display Port
          </button>
        }
      </div>
    </app-form-field>

    <!-- Custom Properties -->
    <app-form-field label="Custom Properties">
      <div class="flex flex-col gap-2">
        @for (prop of customProperties; track trackByIndex(i, prop); let i = $index) {
          <div class="flex items-center gap-2">
            <app-text-input
              class="flex-1"
              [(ngModel)]="prop.key"
              name="customKey-{{ i }}"
              label="Key"
              [disabled]="isViewMode"
              placeholder="Key"
            />
            <app-text-input
              class="flex-1"
              [(ngModel)]="prop.value"
              name="customValue-{{ i }}"
              label="Value"
              [disabled]="isViewMode"
              placeholder="Value"
            />
            @if (!isViewMode) {
              <button
                type="button"
                (click)="removeCustomProperty(i)"
                class="flex-none px-1 text-[13px] font-semibold text-danger hover:underline"
              >
                Remove
              </button>
            }
          </div>
        }
        @if (!isViewMode) {
          <button
            type="button"
            (click)="addCustomProperty()"
            class="self-start px-2 text-[13px] font-semibold text-link hover:underline"
          >
            + Add Custom Property
          </button>
        }
      </div>
    </app-form-field>
  </form>

  <!-- Footer: Cancel + mode-dependent primary (Edit in view mode, else Save) -->
  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button
        type="button"
        (click)="closeDialog()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onPrimary()"
        class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text hover:brightness-90"
      >
        {{ isViewMode ? 'Edit' : 'Save Configuration' }}
      </button>
    </div>
  </ng-template>
</app-modal>
